// apiHelpers.js
import axios from 'axios';

export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Authentication token missing');
  }
  return { Authorization: `Bearer ${token}` };
};

export const getCompanyQueryParams = () => {
  // The company selector and HR Analytics selector keep these values synchronized.
  // Prefer selectedCompanyId as the app-wide canonical company context; use the
  // HR-specific key only as a compatibility fallback for older sessions.
  const selectedCompanyId =
    localStorage.getItem('selectedCompanyId') ||
    localStorage.getItem('hrAnalyticsSelectedCompanyId');

  return selectedCompanyId ? { subCompanyId: selectedCompanyId } : {};
};

export const apiRequest = async (method, url, data = null, extraParams = {}) => {
  const headers = getAuthHeaders();
  const isHrAnalyticsRequest = String(url || '').toLowerCase().includes('/hr-analytics');
  const params = { ...(isHrAnalyticsRequest ? getCompanyQueryParams() : {}), ...(extraParams || {}) };

  const config = {
    method,
    url,
    headers,
    params,
    ...(data && { data })
  };

  try {
    const response = await axios(config);
    return response;
  } catch (error) {
    console.error('API Request failed:', error);
    throw error;
  }
};

// Enhanced axios instance with automatic company selection
export const apiWithCompany = axios.create();

apiWithCompany.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers = {
      ...(config.headers || {}),
      Authorization: `Bearer ${token}`
    };
  }

  const selectedCompanyId =
    localStorage.getItem('selectedCompanyId') ||
    localStorage.getItem('hrAnalyticsSelectedCompanyId');

  // Always include the current selected company when present (even if same as base company).
  if (selectedCompanyId) {
    config.params = {
      ...(config.params || {}),
      subCompanyId: selectedCompanyId
    };
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});


// Build public asset URLs (company logos, etc.) from the API origin.
// REACT_APP_BASE_URL includes /api/, but wwwroot static files are served at the host root.
export const getApiOrigin = () => {
  const configuredApiBase = (
    process.env.REACT_APP_BASE_URL || 'http://localhost:5228/api/'
  ).trim().replace(/\/+$/, '');

  return configuredApiBase.replace(/\/api$/i, '').replace(/\/+$/, '');
};

export const getAbsoluteApiAssetUrl = (assetUrl) => {
  if (typeof assetUrl !== 'string' || !assetUrl.trim()) return null;

  const value = assetUrl.trim();
  if (/^https?:\/\//i.test(value)) return value;

  return `${getApiOrigin()}/${value.replace(/^\/+/, '')}`;
};
